import { Outlet } from "react-router-dom";
import LogoPPAlManar from "@assets/images/logo-ppalmanar.png";

export const AuthPage = () => {
  return (
    <div className="tw-flex tw-flex-col tw-min-h-screen">
      <div className="tw-relative tw-overflow-hidden bg-gradient">
        {/* Decorative blobs */}
        <div
          className="tw-absolute tw-top-[-40px] tw-right-[-40px] tw-w-56 tw-h-56 tw-rounded-full"
          style={{ background: "rgba(255,255,255,0.07)" }}
        />
        <div
          className="tw-absolute tw-bottom-[-30px] tw-left-[-30px] tw-w-40 tw-h-40 tw-rounded-full"
          style={{ background: "rgba(255,255,255,0.05)" }}
        />
        <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-pt-16 tw-pb-16 tw-relative tw-z-10">
          <div
            className="tw-w-20 tw-h-20 tw-rounded-3xl tw-mb-5 tw-flex tw-items-center tw-justify-center"
            style={{
              background: "rgba(255,255,255,0.15)",
              backdropFilter: "blur(8px)",
            }}
          >
            <img
              src={LogoPPAlManar}
              alt="PP Al-Manar"
              className="tw-h-16 tw-object-contain"
            />
          </div>
          <div className="tw-text-2xl tw-font-bold tw-text-white tw-tracking-tight">
            Pesantren Modern Al-Manar
          </div>
          <div className="tw-text-xs tw-text-white/60 tw-mt-1">
            Sistem Informasi Pondok
          </div>
        </div>
      </div>
      <Outlet />
    </div>
  );
};
